import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService, Task, TaskService } from '../../../../core';
import { IntegrationPedido } from './integration-pedido';
import { IntegrationPeriodicidade, periodicidadeMensal, periodicidadeAnual, periodicidadeGeral, isPeriodicidadeMensal, isPeriodicidadeAnual, isPeriodicidadeGeral } from '../integration-periodicidade';
import { IntegrationPedidoHttpService } from './services';

@Component({
    selector: 'sgt-integration-pedido-modal',
    templateUrl: './integration-pedido-modal.component.html',
    styleUrls: ['./integration-pedido-modal.component.less']
})
export class IntegrationPedidoModalComponent implements OnInit {
    entity = new IntegrationPedido();
    elModal: any;
    @Output() afterExecuteIntegration = new EventEmitter<any>();

    @ViewChild('form') form: NgForm;
    periodicidades: IntegrationPeriodicidade[] = [
        periodicidadeMensal,
        periodicidadeAnual,
        periodicidadeGeral
    ];

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private taskService: TaskService,
                private integrationPedidoHttpService: IntegrationPedidoHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.elModal).find('#integrationPedidoPeriodicidade').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    private clear() {
        // this.form.resetForm();
        this.entity.clear();
    }

    open() {
        this.clear();

        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    private beforeExecute() {
        if (!this.isPeriodicidadeGeral()) {
            this.entity.dataInicialBase = null;
        }
    }

    /** Executa as integrações de leitura dos pedidos com os sistemas ERP's manualmente */
    execute() {
        if (this.form.valid) {
            this.beforeExecute();

            const task = new Task('Sincronizando pedidos com o ERP', 'Executando sincronização dos pedidos com o sistema ERP');
            this.taskService.add(task, task.description);
            this.integrationPedidoHttpService.execReadIntegrationManual(this.entity)
                .subscribe(
                    () => {
                        this.taskService.success(task, 'Sincronização dos pedidos com o sistema ERP realizada com sucesso');
                        this.afterExecuteIntegration.emit();
                    },
                    (error: ApiError) => this.taskService.error(task, 'Erro ao realizar a sincronização dos pedidos com o sistema ERP', error.message, error)
                );

            this.close();
        } else {
            this.messageService.info('Informe todos os campos corretamente para executar a sincronização dos pedidos com o ERP', 'Informação');
        }
    }

    /** Verifica se a periodicidade selecionada é geral */
    isPeriodicidadeGeral(): boolean {
        if (!this.entity) {
            return false;
        }
        return isPeriodicidadeGeral(this.entity.periodicidade);
    }

    getDescricaoPeriodicidade(periodicidade: number): string {
        if (isPeriodicidadeMensal(periodicidade)) {
            return 'Mensal - Pedidos lançados a partir do mês anterior';
        } else if (isPeriodicidadeAnual(periodicidade)) {
            return 'Anual - Pedidos lançados a partir do ano anterior';
        } else if (isPeriodicidadeGeral(periodicidade)) {
            return 'Geral - Pedidos lançados a partir de uma data específica'
        }
        return '';
    }
}
